import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export type HomeTab = 'recruiter' | 'bench' | 'feed';

/**
 * Broadcasts the currently-active Home tab so the parent IndexLayout
 * can hide the left profile sidebar on the new dashboard tabs and
 * only show it on the Activity Feed tab.
 */
@Injectable({ providedIn: 'root' })
export class HomeTabStateService {
  private readonly _activeTab$ = new BehaviorSubject<HomeTab>('recruiter');
  readonly activeTab$ = this._activeTab$.asObservable();

  setActiveTab(tab: HomeTab) { this._activeTab$.next(tab); }
  reset() { this._activeTab$.next('recruiter'); }
}
